import { Dialog } from '@app/hoc/dialog/Dialog';
import { DialogContent, CircularProgress } from '@mui/material';
import { Typography } from '@app/components';

// admin-emailbeheer blok A stap 5, opdracht §5.2: rendered on request from the stored
// template + context, never archived HTML - see EmailCustomerAdminFacadeImpl.viewRendered's own
// javadoc. Shown in a sandboxed iframe with no allow-scripts/allow-same-origin: the variables a
// past send used can contain customer-entered text (a code name, for example), which must never
// execute as active content in the admin panel.
export const RenderedMailDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  subject?: string;
  template?: string;
  html?: string;
}> = ({ open, onClose, loading, subject, template, html }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      headerTitle={subject || 'Rendered mail'}
      headerSubtitle={template}
    >
      <DialogContent className="p-0">
        {loading ? (
          <div className="flex h-[400px] items-center justify-center">
            <CircularProgress />
          </div>
        ) : html ? (
          <iframe title="Rendered mail preview" sandbox="" srcDoc={html} className="h-[70vh] w-full border-0" />
        ) : (
          <Typography variant="m" className="p-8 text-gray-500">
            Nothing to show.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
